import { createApiClient } from 'api/createApiClient'
import { CEREBRO_ACCESS_TOKEN } from 'const/localStorage'
import { userHasCustomerServicePermissions } from 'helpers/featurePermissions'
import { invalidateCache } from 'reducers/cache'
import { selectDomainValue, selectUserFeaturePermissions } from 'selectors/auth'
import storeRegistry from 'utilities/storeRegistry'

import { shouldInvalidateCache } from './caching'

export const orgScopedApiClient = createApiClient()
orgScopedApiClient.interceptors.request.use((config) => {
    const accessToken = localStorage.getItem(CEREBRO_ACCESS_TOKEN)

    const state = storeRegistry.getState()
    if (!state) {
        return config
    }

    const isImpersonating = selectDomainValue(state, ['userIsImpersonating'])
    const isCustomerService = userHasCustomerServicePermissions(
        selectUserFeaturePermissions(state)
    )

    const organizationId = selectDomainValue(state, ['organizationId'])
    const organizationGroupId = selectDomainValue(state, [
        'organizationGroupId',
    ])

    if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
    }

    // A request that already carries an org scope (print routes, impersonated
    // renders) has picked its own org deliberately; applying the ambient session
    // scope on top would silently redirect it at another organization's data.
    const hasExplicitOrgScope =
        !!config.headers['x-dsi-org-id'] ||
        !!config.headers['x-dsi-org-group-id']

    if (!hasExplicitOrgScope) {
        if (organizationGroupId && isImpersonating && isCustomerService) {
            config.headers['x-dsi-org-group-id'] = organizationGroupId
        } else if (organizationId) {
            config.headers['x-dsi-org-id'] = organizationId
        }
    }

    if (shouldInvalidateCache(config)) {
        storeRegistry.dispatch(invalidateCache())
    }

    return config
})
